export default function Marquee({ items, className = "", itemClassName = "", reverse = false }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} aria-hidden="true">
      <div className={`inline-flex w-max animate-marquee will-change-transform ${reverse ? "marquee-reverse" : ""}`}>
        {row.map((t, i) => (
          <span key={i} className={`inline-flex items-center ${itemClassName}`}>
            <span className="mx-5 md:mx-8">{t}</span>
            <span className="text-en-pink text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
